/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { isMobile } from 'react-device-detect'
import { ListView } from 'antd-mobile'
import { get } from 'lodash'
import PageLoading from '@components/PageLoading'
// css
import styled, { Theme } from '@themes/theme'
import { ChatArea } from '@styles/base.style'
import { PICK_ESTATE, PICK_TRACK_TYPE, PickListSource, PickTrack } from '@store/pickStore'
import useRootStore from '@store/useRootStore'
// import { delay } from '@utils/utils'
import { BET_HIT_STATE } from 'adv-protocol/src/GameCommon'
import { delay } from '@utils/utils'
import { AdvEmpty } from '@components/AdvEmpty'
import { EMPTY_ICON } from '@constants/index'
import PickListItem from './PickListItem'

// const { Option } = Select

const BetHistoryWrap = styled.div`
  ${ChatArea};
  position: relative;
  top: 0;
  width: 100%;
  height: 100%;

  .am-accordion > .am-accordion-item > .am-accordion-header {
    padding: 10px 12px;
    border: 1px solid ${props => props.theme.color.mainBg} ;
  }
  .am-accordion-borderless > .am-accordion-item > .am-accordion-content > .am-accordion-content-box {
    padding: 10px 16px;
    background: ${props => props.theme.color.accordion1};
  }
`
const LoadingStyle = (theme: Theme) => css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: calc(100vh - 130px);
  background: ${theme.color.contentsBg};
`

interface PickListProps {
  currentIndex: number
  currentFilter: number
  fetchItems?: (
    index: number,
    size: number,
    filter: number,
    order: number,
    resetForce: boolean,
  ) => Promise<PickListSource>
  setFetchPickList?: (fn: () => void) => void
}

interface PickListState {
  // antd-mobile의 ListView.DataSource 가 any로 설정되어 있어서 어쩔수 없이 any로 한다.
  dataSource: any
  isLoading: boolean
  hasMore: boolean
}

const PAGE_SIZE = 20

// const i = 0
// const PICKS = [<AvailablePick />, <CompletePick />, <MyPick />, <PurchasePick />, <SoldPick />]

function getEmptyPage(isLoading: boolean) {
  return <div css={LoadingStyle}>{isLoading ? <PageLoading /> : <Fragment />}</div>
}

function MyBody(props: any) {
  const { children } = props
  return <div className="am-list-body my-body">{children}</div>
}

class PickList extends React.PureComponent<PickListProps, PickListState> {
  // private lv: any = undefined

  private mounted = false

  private lastIndex = -1

  private lastFilter = -1

  constructor(props) {
    super(props)

    const dataSource = new ListView.DataSource({
      rowHasChanged: (row1, row2) => row1 !== row2,
    })

    this.state = {
      dataSource,
      isLoading: false,
      hasMore: true,
    }

    this.fetch = this.fetch.bind(this)

    const { setFetchPickList } = props
    setFetchPickList(this.fetch)
  }

  componentDidMount() {
    const { currentIndex } = this.props
    this.lastIndex = currentIndex
    this.mounted = true

    this.fetch(true)
  }

  // reset() {
  //   const { dataSource } = this.state
  //   const newSource = dataSource.cloneWithRows([])
  //   this.setState({
  //     dataSource: newSource,
  //     isLoading: true,
  //     hasMore: false,
  //   })
  // }

  async fetch(reset = false) {
    const { dataSource, isLoading, hasMore } = this.state
    const { currentIndex, fetchItems } = this.props

    if (reset === true) {
      const newSource = dataSource.cloneWithRows([])
      this.setState({
        dataSource: newSource,
        isLoading: true,
        hasMore: true,
      })
    } else {
      if (isLoading || !hasMore) {
        return
      }

      this.setState({ isLoading: true })
    }

    const fetched: PickListSource = await fetchItems(currentIndex, PAGE_SIZE, this.lastFilter, 0, reset)

    // TEST:
    // let fetched = { lastFetched: [], hasMore: false }
    // if (index === 0) {
    //   const tmp: BettingRecordSource = await fetchItems(index, PAGE_SIZE, reset)
    //   fetched = { lastFetched: tmp.lastFetched, hasMore: tmp.hasMore }
    // }
    delay(1)

    if (fetched) {
      const newSource = dataSource.cloneWithRows(fetched.tracks)

      // TEST: loading test
      // await delay(250)

      this.setState({
        isLoading: false,
        dataSource: newSource,
        hasMore: fetched.hasMore,
      })
    } else {
      this.setState({
        isLoading: false,
        dataSource: dataSource.cloneWithRows([]),
        hasMore: false,
      })
    }
  }

  onEndReached = async event => {
    await this.fetch()
  }

  render() {
    const { isLoading, dataSource } = this.state
    const { currentIndex, currentFilter } = this.props
    const { lastIndex, lastFilter } = this
    this.lastIndex = currentIndex
    this.lastFilter = currentFilter

    let needFetch = false

    if (currentIndex !== lastIndex || currentFilter !== lastFilter) {
      needFetch = true
    }

    if (this.mounted === false) {
      return getEmptyPage(true)
    }

    if (needFetch) {
      this.fetch(true)
    }

    // TODO: 복수개의 ListView 의 페이지 끝 도달 이벤트가 처리되어 아래와 같이 예외 처리 추가! 근본적 해결책은?
    const endReachedHandler = this.onEndReached

    const getPickTrackType = (track: PickTrack) => {
      let pickTrackType = PICK_TRACK_TYPE.NONE
      if (currentIndex === 0) {
        // 픽 거래소
        if (track.estate === PICK_ESTATE.PUBLISHED) {
          pickTrackType = PICK_TRACK_TYPE.PUBLISHED
        } else if (track.estate === PICK_ESTATE.PURCHASED) {
          pickTrackType = PICK_TRACK_TYPE.PURCHASED
        }
      } else {
        switch (track.hitState) {
          case BET_HIT_STATE.ONGOING:
            pickTrackType = PICK_TRACK_TYPE.ONGOING
            break
          case BET_HIT_STATE.SUCCESS:
            pickTrackType = PICK_TRACK_TYPE.SUCCESS
            break
          case BET_HIT_STATE.FAIL:
            pickTrackType = PICK_TRACK_TYPE.FAIL
            break
          case BET_HIT_STATE.CANCEL:
            pickTrackType = PICK_TRACK_TYPE.EXCEPTION
            break
        }
      }
      return pickTrackType
    }

    const RenderRow = (rowData, sectionID, rowID) => {
      const trackType = getPickTrackType(rowData)
      return <PickListItem currentIndex={currentIndex} track={rowData} trackType={trackType} />
    }

    const renderFooter = () => {
      const { _dataBlob } = dataSource
      const listData = get(_dataBlob, 's1')
      let footer = null
      if (isLoading) {
        footer = <PageLoading />
      } else if (listData.length > 0) {
        footer = <Fragment />
      } else if (currentIndex === 0) {
        footer = <AdvEmpty ico={EMPTY_ICON.PICK} />
      } else if (currentIndex === 1) {
        footer = <AdvEmpty ico={EMPTY_ICON.PICK_SALE} />
      } else if (currentIndex === 2) {
        footer = <AdvEmpty ico={EMPTY_ICON.PICK_PURCHASE} />
      }
      return <div css={{ textAlign: 'center' }}>{footer}</div>
    }

    return (
      <Fragment>
        <BetHistoryWrap className="bet-history-wrap">
          <ListView
            // ref={el => (this.lv = el)}
            css={{ height: 'calc(100% - 78px)' }}
            dataSource={dataSource}
            renderFooter={renderFooter}
            renderRow={RenderRow}
            className="am-list"
            pageSize={PAGE_SIZE}
            useBodyScroll={isMobile}
            renderBodyComponent={() => <MyBody />}
            scrollRenderAheadDistance={500}
            onEndReached={endReachedHandler}
            onEndReachedThreshold={10}
          />
        </BetHistoryWrap>
      </Fragment>
    )
  }
}

const Wrapper: React.FC<PickListProps> = (props: PickListProps) => {
  const { pickStore } = useRootStore()

  const listProps = {
    ...props,
    fetchItems: pickStore.fetchItems,
    setFetchPickList: pickStore.setFetchPickList,
  }

  return <PickList {...listProps} />
}

export default Wrapper
